






















































import { Vue, Component, Watch } from 'vue-property-decorator';
import { client, xml } from '@xmpp/client';
// import debug from '@xmpp/debug';
import XGplayer from '@/components/XGplayer.vue';
import { Popup, Icon, Swipe, SwipeItem, Toast } from 'vant';
import lazyLoad from 'vue-lazyload';
import { isWeiXin, isMobile, isJSON, replaceAllImg } from '@/common/ts/common';
import { getUnionId, getBaseInfo } from '../api';
import VueLazyload from 'vue-lazyload';

Vue.use(Popup)
  .use(Icon)
  .use(Toast)
  .use(lazyLoad, {
    loading:
      'https://image2.cqcb.com/d/file/topics/activity/2020-05-11/Ap8Rg9oj-img-place-holder_cr.png',
  });

const liveVideoCovers = [
  'https://image2.cqcb.com/d/file/topics/activity/2020-06-09/1591699787883.jpg',
  'https://image2.cqcb.com/d/file/topics/activity/2020-06-09/1591699811031.jpg',
  'https://image2.cqcb.com/d/file/topics/activity/2020-06-09/1591699827966.jpg',
];
const otherVideoCovers = [
  'https://image2.cqcb.com/d/file/topics/activity/2020-06-09/1591699731423.jpg',
  'https://image2.cqcb.com/d/file/topics/activity/2020-06-09/1591699760333.jpg',
  'https://image2.cqcb.com/d/file/topics/activity/2020-06-09/1591699678573.jpg',
  'https://image2.cqcb.com/d/file/topics/activity/2020-07-13/ZI7oJddP-1594633903504.jpg',
];

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate', // for vue-router 2.2+
]);

@Component({
  name: 'VideoList',
  components: {
    XGplayer,
  },
})
export default class VideoList extends Vue {
  roomBaseInfo: any = {};
  showConfIntro = false;
  isWechatEnv = false;
  listHeight = 0;
  videos: any[] = [];

  get currentVideo() {
    return this.videos[Number(this.$route.params.videoNumber) - 1];
  }

  async created() {
    const moreVideoUrl = `${process.env.VUE_APP_PUBLIC_PATH}cq-expo-hotpot-live/`;
    this.videos = [
      {
        cover: otherVideoCovers[0],
        desc: '悦动重庆，一切会更好',
        showInVideoList: false,
        start_time: 1577808000000,
        title: '大会先导片',
        videoUrl:
          'https://recordcdn.quklive.com/upload/vod/user1462960877450854/1591693384287906/18/video.m3u8',
        url: `${moreVideoUrl}videos/1`,
        id: 1,
      },
      {
        cover: otherVideoCovers[1],
        desc: '大道无穷，未来可期',
        showInVideoList: false,
        start_time: 1577808000000,
        title: '大会预告片',
        videoUrl:
          'https://recordcdn.quklive.com/upload/vod/user1462960877450854/1591693384375908/18/video.m3u8',
        url: `${moreVideoUrl}videos/2`,
        id: 2,
      },
      {
        cover: otherVideoCovers[2],
        desc: '往届大会精彩瞬间',
        showInVideoList: false,
        start_time: 1577808000000,
        title: '大会回顾片',
        videoUrl:
          'https://recordcdn.quklive.com/upload/vod/user1462960877450854/1591693027113933/18/video.m3u8',
        url: `${moreVideoUrl}videos/3`,
        id: 3,
      },
      {
        cover: otherVideoCovers[3],
        desc: '创新者大会背后的故事',
        showInVideoList: false,
        start_time: 1577808000000,
        title: '大会花絮篇',
        videoUrl:
          'http://recordcdn.quklive.com/upload/vod/user1462960877450854/1594625005174944/18/video.m3u8',
        url: `${moreVideoUrl}videos/4`,
        id: 4,
      },
    ];

    this.isWechatEnv = isWeiXin();
    // 获取所有直播基础信息
    const liveRoomIds = [1, 2, 3];
    const ret = await Promise.all(
      liveRoomIds.map((item: number) => getBaseInfo(item)),
    );
    this.roomBaseInfo = ret[0].data;
    const mappedLiveRoomInfos = ret.map((item: any, index: number) => ({
      title: item.data.title,
      desc: item.data.subtitle,
      cover: liveVideoCovers[index],
      start_time: item.data.start_time * 1000,
      url: `${moreVideoUrl}room/${index + 1}`,
      showInVideoList: false,
      id: item.data.act_id,
    }));
    this.videos = [...this.videos, ...mappedLiveRoomInfos];
  }
  mounted() {
    this.getChatRoomHeight();
  }

  onNavTo(item: any) {
    if (Date.now() < item.start_time) {
      return Toast('敬请期待');
    }
    location.href = item.url;
  }

  // 计算chatRoom(tab content容器)高度
  getChatRoomHeight() {
    const playerHeight = (this.$refs.player as Vue).$el.clientHeight;
    const roomTitleHeight = (this.$refs.roomTitle as HTMLDivElement)
      .clientHeight;
    const tabContentHeight =
      window.innerHeight - playerHeight - roomTitleHeight;
    this.listHeight = tabContentHeight;
  }

  // 开关大会介绍弹窗
  toggleConfIntro() {
    this.showConfIntro = !this.showConfIntro;
  }
}
